<!-- <sm-title-bar pageTitle="Businesses"></sm-title-bar> -->

<mat-card appearance="outlined" *ngIf="!loader">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="messageList" 
        [showMenuButton]="true"  [showFilter]="true" [menuDropdownTemplate]="menuTemplate" [showPagination]="true" [itemsPerPage]="10">
      </sm-data-table>
    </div>
  </mat-card>

  <div *ngIf="loader" class="loader">
    <mat-spinner></mat-spinner>
  </div>
  
  
  <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item (click)="viewDetails(rowvalue.hashId)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View Details</span>
    </button>
    <button mat-menu-item (click)="viewEmployees(rowvalue.hashId)">
      <mat-icon class="material-icons-outlined">badge</mat-icon>
      <span>Employees</span>
    </button>
    <button mat-menu-item (click)="viewDocs(rowvalue.hashId)">
      <mat-icon class="material-icons-outlined">inventory</mat-icon>
      <span>Documents</span>
    </button>
    <button mat-menu-item (click)="viewServices(rowvalue.hashId)">
      <mat-icon class="material-icons-outlined">store</mat-icon>
      <span>Services</span>
    </button>
    <button mat-menu-item (click)="viewBookings(rowvalue.hashId)">
      <mat-icon class="material-icons-outlined">menu</mat-icon>
      <span>Bookings</span>
    </button>
    <button mat-menu-item (click)="viewOnlinePayments(rowvalue.hashId)">
      <mat-icon class="material-icons-outlined">badge</mat-icon>
      <span>Online payments</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.isActive === 'Active'" (click)="deactivate(rowvalue)">
      <mat-icon class="material-icons-outlined">person_add_disabled</mat-icon>
      <span>Deactivate</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.isActive === 'Deactive' || rowvalue.isActive === 'Unavailable' " (click)="activate(rowvalue)">
        <mat-icon class="material-icons-outlined">person_add</mat-icon>
        <span>Activate</span>
      </button>
  </ng-template>